import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import SavvytronWebsite from './pages/SavvytronWebsite';
import LoginPage from './pages/LoginPage';
import PlansPage from "./pages/PlansPage";
import './index.css';
import AdminLayout from "./pages/admin/AdminLayout";
import ContactPage from './pages/ContactPage';
import ServicesPage from './pages/ServicesPage';

import DineshLogin from "./components/DineshLogin";
import ProtectedDineshRoute from "./auth/ProtectedDineshRoute";

import ScrollToTop from "./components/ScrollToTop";   // <-- ADD THIS



function App() {
  return (
    <Router>

      {/* Scroll to top on every page change */}
      <ScrollToTop />

      <Routes>
        <Route path="/" element={<SavvytronWebsite />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/plans" element={<PlansPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/services" element={<ServicesPage />} />

        <Route path="/Dinesh" element={<DineshLogin />} />
        <Route
          path="/Dinesh/admin"
          element={
            <ProtectedDineshRoute>
              <AdminLayout />
            </ProtectedDineshRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
